import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import img from "../assets/img/logo22.png";
import uc from "../assets/img/image_ucom.png";
import { menu } from "../translate";
import LockIcon from "@mui/icons-material/Lock";
import _ from 'lodash'
import Account from "../helpers/Account";
import Api from "../Api";
import { profileUrsRequest } from "../store/actions/users";
import { useDispatch, } from "react-redux";
import { Helmet } from "react-helmet";
const { REACT_APP_SERVER } = process.env;
import ats from '../assets/img/logo_light.png'
import { REACT_APP_API_URL } from '../config';



function UrsUsed(props) {
    const [type, setType] = useState('')
    const [type_did, setTypeDid] = useState('did')
    const [provider, setProvider] = useState('')
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [newData, setData] = useState('')
    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.getUsed()

                setData(data)
            } catch (e) {
            }
        })()
    }, [])
    useEffect(() => {
        if (!Account.getUrsToken()) {
            navigate('/admin_login')
        }
    }, [])

    const handleDownload = async () => {
        const url = `${REACT_APP_API_URL}/rest/report_exel?id=${provider}&type=${type_did}`;

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'report.csv'); // optional: sets a default filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleIncludedDownload = async () => {
        const url = `${REACT_APP_API_URL}/rest/get_included_files?id=${'KDJKJSDFHSDHKFBSDIUFHWEUBbdjfbwek'}`;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'included.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    const handleChangeProvider = (ev) => {
        setProvider(ev)
        if (+ev === 11 || +ev === 60 || ev === "qar") {
            setTypeDid('provider')
        }
    }

    useEffect(() => {
        (async () => {
            await dispatch(profileUrsRequest())
        })()
    }, [])
    const tableRef = useRef(null);
    const stickyRowRef = useRef(null);

    useEffect(() => {
        const table = tableRef.current;
        if (!table) return;

        const tbody = table.querySelector('tbody');
        if (!tbody || !tbody.rows.length) return;

        const firstRow = tbody.rows[0];

        // Remove old sticky row if exists
        if (stickyRowRef.current) {
            stickyRowRef.current.remove();
        }

        // Clone row and put it in its own table
        const stickyTable = document.createElement('table');
        stickyTable.style.position = 'fixed';
        stickyTable.style.top = '0px';
        stickyTable.style.zIndex = '1000';
        stickyTable.style.background = '#fff';
        stickyTable.style.borderCollapse = 'collapse';
        stickyTable.style.display = 'none';
        stickyTable.className = table.className;

        const clonedRow = firstRow.cloneNode(true);
        const clonedTbody = document.createElement('tbody');
        clonedRow.style.height = '50px';
        clonedRow.style.display = 'table-row';
        clonedTbody.appendChild(clonedRow);
        stickyTable.appendChild(clonedTbody);
        document.body.appendChild(stickyTable);

        stickyRowRef.current = stickyTable;

        const updateWidths = () => {
            const originalCells = firstRow.children;
            const clonedCells = clonedRow.children;
            for (let i = 0; i < originalCells.length; i++) {
                clonedCells[i].style.width = `${originalCells[i].getBoundingClientRect().width}px`;
                clonedCells[i].style.height = '50px';
                clonedCells[i].style.verticalAlign = 'middle';
                clonedCells[i].style.textAlign = 'center';
            }

            const rect = table.getBoundingClientRect();
            stickyTable.style.left = `${rect.left + window.scrollX}px`;
            stickyTable.style.width = `${rect.width}px`;
        };

        const toggleSticky = () => {
            const tableTop = table.offsetTop;
            const tableBottom = tableTop + table.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY > tableTop && scrollY < tableBottom) {
                stickyTable.style.display = 'table';
                updateWidths();
            } else {
                stickyTable.style.display = 'none';
            }
        };

        window.addEventListener('scroll', toggleSticky);
        window.addEventListener('resize', updateWidths);

        updateWidths();
        toggleSticky();

        return () => {
            window.removeEventListener('scroll', toggleSticky);
            window.removeEventListener('resize', updateWidths);
            if (stickyRowRef.current) stickyRowRef.current.remove();
        };
    }, [newData]);
    const handleSummaryDownload = () => {
        const url = `${REACT_APP_API_URL}/rest/users/report_summary`
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'summary.csv')
        document.body.appendChild(link)
        link.click()
        link.remove()
    }
    return (
        <>
            <Helmet>
                <title>Urs</title>
            </Helmet>
            <header className="header">
                <div className="header_container container" style={window.innerWidth > 1030 ? {} : { maxWidth: '100%' }}>
                    <div className="header_block">
                        <div className="left">
                            {REACT_APP_SERVER === 'Beeline' ? <Link to="/urs">
                                <figure>
                                    <img style={{ width: 100 }} src={img} alt='' />
                                </figure>
                            </Link> : REACT_APP_SERVER === 'ATS' ? <Link to="/urs">
                                <figure>
                                    <img style={{ width: 100 }} src={ats} alt='' />
                                </figure>
                            </Link> : <Link to="/urs">
                                <figure>
                                    <img src={uc} alt='' />
                                </figure>
                            </Link>}

                        </div>
                        <div className="right">
                            <div className="logout">
                                <Link to="/urs_online"> {menu.online[0]}</Link>
                            </div>
                            <div className="logout">
                                <Link to="/admin_login"><LockIcon
                                    sx={{ color: '#CD405F', fontSize: 20 }} /> {menu.logout[0]}</Link>
                            </div>

                        </div>

                    </div>
                </div>
            </header>
            <div className="urs_table" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className=" tableParent  file" style={window.innerWidth <= 1024 ? { overflow: 'scroll', background: 'white', padding: 35, width: '95vw', overflowY: 'hidden', } : { overflowY: 'hidden', background: 'white', padding: 35, width: '75vw' }}>
                    <div  className='d-flex align-items-center justify-content-end' style={{ margin: '20px 0' }}>
                        <span className='addBtn' onClick={() => setType(true)}>Ընտրել DID-ի տեսակը</span>
                        <span className="addBtn" style={{ margin: '0 20px' }} onClick={handleSummaryDownload}>
                            Ներբեռնել հաշվետվությունը
                        </span>
                        <span className="addBtn" style={{ margin: '0 20px' }} onClick={handleIncludedDownload}>
                            Ներբեռնել ներառված համարները
                        </span>
                    </div>
                    <table ref={tableRef} cellPadding="0" cellSpacing="0">

                        {newData ? <tbody dangerouslySetInnerHTML={{ __html: newData }} /> :
                            <tbody><tr><td style={{ textAlign: 'center' }} colSpan={17}>Loading...</td></tr></tbody>}
                        <tr>
                            <td colSpan={4} />
                            <td>{newData?.gsmm}</td>
                            <td>{newData?.sipp}</td>
                            <td>{newData?.didd}</td>
                            <td>{newData?.ucomsipp}</td>
                            <td>{newData?.all}</td>
                        </tr>

                    </table>
                </div>
            </div>

            {type && (
                <div className="modal-backdrop-my" onClick={() => setType(false)}>
                    <div className="modal-content-my" onClick={(e) => e.stopPropagation()}>
                        <select value={provider} onChange={(ev) => { handleChangeProvider(ev.target.value) }} style={{ padding: 10, width: "100%", marginBottom: 20 }}>
                            <option value="">Select</option>
                            <option value="1">Ucom</option>
                            <option value="2">Ucom Peer</option>
                            <option value="4">Telegram</option>
                            <option value="11">011 Fix numbers</option>
                            <option value="60">060 Fix numbers</option>
                            <option value="qar">4 Digit numbers</option>
                            <option value="qar8">3748000 numbers</option>
                        </select>
                        <button className="addBtn" onClick={handleDownload}>Download</button>
                    </div>
                </div>
            )}
        </>

    );
}

export default UrsUsed;
